import BaseCtrl from 'edge/platform/base/BaseCtrl';
import _ from 'lodash';

const fn = ($scope, claimViewModel) => {
    const ctrl = Object.create(BaseCtrl);
    let lossCauseTypesArray;
    ctrl.init = () => {
        $scope.claimVm = claimViewModel();
        lossCauseTypesArray = $scope.claimVm.lossCause.value.typelist.codes;
    };

    ctrl.next = (nextFn) => {
        const miscellaneous = $scope.claimVm.lossCause.value.code === 'miscellaneous';
        nextFn($scope.claimVm, {
            'miscellaneous': miscellaneous
        });
    };

    ctrl.selectLossCause = (clickedTileCode) => {
        $scope.claimVm.lossCause.value = _.find(lossCauseTypesArray, (cause) => {
            return cause.code === clickedTileCode;
        });
    };

    return ctrl.create($scope);
};

fn.$inject = ['$scope', 'claimViewModel'];

export default fn;
